import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { GetTaskResponse } from '../interfaces/get-task';
import { GetTasksParams, GetTasksResponse, UserTask } from '../interfaces/get-tasks';
import moment from 'moment';

export interface TaskState {
  running: boolean;
  tasks: UserTask[];
  options: GetTasksParams;
  errorCode: number | null;
}

const initialState: TaskState = {
  running: false,
  tasks: [],
  options: {
    dateInit: moment().startOf('d').toISOString(),
    dateEnd: moment().endOf('d').toISOString(),
  },
  errorCode: null,
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    getTaskInitApiAction: (state) => {
      state.errorCode = null;
    },
    getTaskSuccessApiAction: (state, action: PayloadAction<GetTaskResponse>) => {
      state.running = action.payload.running;
    },
    getTaskFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
      state.running = false;
    },
    getTasksInitApiAction: (state) => {
      state.errorCode = null;
    },
    getTasksSuccessApiAction: (state, action: PayloadAction<GetTasksResponse>) => {
      state.tasks = action.payload.tasks;
    },
    getTasksFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    setRunningAction: (state, action: PayloadAction<{ running: boolean }>) => {
      state.running = action.payload.running;
    },
    taskClearAction: (state) => {
      state.running = false;
      state.errorCode = null;
    },
    setOptionsAction: (state, action: PayloadAction<GetTasksParams>) => {
      state.tasks = [];
      state.options = action.payload;
    },
    resetOptionsAction: (state) => {
      state.options = {
        dateInit: moment().startOf('d').toISOString(),
        dateEnd: moment().endOf('d').toISOString(),
      };
    },
  },
});

export const {
  getTaskInitApiAction,
  getTaskSuccessApiAction,
  getTaskFailureApiAction,
  getTasksInitApiAction,
  getTasksSuccessApiAction,
  getTasksFailureApiAction,
  setRunningAction,
  setOptionsAction,
  taskClearAction,
  resetOptionsAction,
} = taskSlice.actions;

export default taskSlice.reducer;
